export default function () {
  const swiper = new Swiper('.js-topics-slider', {
    watchSlidesProgress: true,
    slidesPerView: 1,
    spaceBetween: 20,
    loop: true,
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
    breakpoints: {
      768: {
        slidesPerView: 2.5,
        spaceBetween: 20,
      },
      1024: {
        slidesPerView: 3.5,
        spaceBetween: 30,
      },
    },
    on: {
      init: () => {
        $('.swiper-slide-next').next().next().css('opacity', '0.4');
      },
      slideChange: (swiper) => {
        swiper.update(true);
        $('.swiper-slide-visible').css('opacity', '');
        $('.swiper-slide-visible').removeClass('last-slide');
        $('.swiper-slide-visible').last().addClass('last-slide');
      },
    }
  });
}